import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const formatPrice = (n) => `€ ${Number(n).toFixed(2)}`;
export const effectivePrice = (item) => (item.promo_price != null ? item.promo_price : item.price);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return typeof d === "string" ? d : "Errore";
};
